import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { globals, TwoFactorOption, VerificationType } from '../../../globals';
import { getEnumString, getEnumValue } from '../../enum-helper';

@Component({
  selector: 'ez-enrollment-options',
  imports: [
    MatIconModule,
  ],
  templateUrl: './enrollment-options.component.html',
  styleUrls: ['./enrollment-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnrollmentOptionsComponent implements OnInit {
  verificationOptions: TwoFactorOption[] = [];
  canSkip = false;
  hasVerifiedOption = false;

  readonly #elementRef = inject(ElementRef);

  ngOnInit(): void {
    const getAttribute = this.#elementRef.nativeElement.getAttribute.bind(this.#elementRef.nativeElement);

    this.verificationOptions = globals.twoFactorOptions;

    this.canSkip = getAttribute('can-skip') === 'can-skip';
    this.hasVerifiedOption = getAttribute('has-verified-option') === 'has-verified-option';
  }

  getTypeCaps(verificationType: VerificationType): string {
    return getEnumString(verificationType, VerificationType)?.toUpperCase() ?? '';
  }

  isAuthenticator(verificationType: VerificationType): boolean {
    return getEnumValue(verificationType, VerificationType) === VerificationType.AUTHENTICATOR;
  }

  getIcon(verificationType: VerificationType): string {
    switch (getEnumValue(verificationType, VerificationType)) {
      case VerificationType.SMS:
        return 'phone_android';

      case VerificationType.EMAIL:
        return 'email';

      case VerificationType.AUTHENTICATOR:
        return 'qr_code_scanner';

      default: return '';
    }
  }

  getOptionTitle(verificationType: VerificationType): string {
    switch (getEnumValue(verificationType, VerificationType)) {
      case VerificationType.SMS:
        return 'Text';

      case VerificationType.EMAIL:
        return 'Email';

      case VerificationType.AUTHENTICATOR:
        return 'Authenticator';

      default: return '';
    }
  }

  getOptionDescription(option: TwoFactorOption): string {
    switch (getEnumValue(option.verificationType, VerificationType)) {
      case VerificationType.SMS:
        return option.isVerified
          ? `(${option.optionData.display.slice(0, 3)}) ${option.optionData.display.slice(3, 6)}-${option.optionData.display.slice(6)}`
          : 'Add a phone number so you can sign in via phone.';

      case VerificationType.EMAIL:
        return option.isVerified
          ? option.optionData.display
          : 'Add an e-mail address so you can sign in via e-mail.';

      case VerificationType.AUTHENTICATOR:
        return option.isVerified
          ? ''
          : 'Set up a third party authenticator to verify your identity.';

      default: return '';
    }
  }
}
